export default function TopBar() {
  return (
    <header className="cf-topbar">
      <img
        src="/logo-wordmark-white.png"
        alt="커피파인더"
        className="cf-topbar__logo"
      />
      <div className="cf-topbar__spacer" />
      <a
        href="https://smore.im/form/pJFD2vQDtz"
        target="_blank"
        rel="noopener noreferrer"
        className="cf-header-action"
        aria-label="참여하기"
        title="참여하기"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="8" y="2" width="8" height="4" rx="1" />
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
          <path d="M9 13l2 2 4-4" />
        </svg>
      </a>
    </header>
  );
}
